import moment from 'moment-timezone';
import {
  ICustomFieldTableColumn,
  TCustomFieldTableValue,
  TCustomFieldValues
} from 'volta/models/types/customFieldDefinition';
import { parseNumber } from 'volta/utils/math-utils';

import { action } from '@ember/object';
import Component from '@glimmer/component';

interface IArgs {
  rows: TCustomFieldValues[];
  columns: ICustomFieldTableColumn[];
  onChange?: (rows: TCustomFieldValues[]) => void;
}

type TIndexableRow = Exclude<TCustomFieldValues, 'index'> & { index?: number };

export default class CustomFieldsEditorTable extends Component<IArgs> {
  get rows(): TIndexableRow[] {
    return (this.args.rows ?? []).map((r, index) => ({ ...r, index }));
  }

  @action
  handleChange(column: ICustomFieldTableColumn, row: TIndexableRow, value: any) {
    let newValue: TCustomFieldTableValue;
    if (column.fieldType === 'DATE') {
      newValue = moment(value).format('YYYY-MM-DD');
    } else if (column.fieldType === 'NUMBER') {
      newValue = parseNumber(value);
    } else {
      newValue = value;
    }
    this.submit(
      this.rows.map((r: TIndexableRow) => {
        if (r.index === row.index) {
          return { ...r, [column.id]: newValue };
        }
        return r;
      })
    );
  }

  @action
  handleAddRow() {
    const { columns } = this.args;
    const newRow: TCustomFieldValues = {};
    columns.forEach((col) => {
      newRow[col.id] = undefined;
    });
    this.submit([...this.rows, newRow]);
  }

  @action
  handleRemoveRow(row: TIndexableRow) {
    this.submit(this.rows.filter((_r: TIndexableRow, i) => i !== row.index));
  }

  submit(rows: TIndexableRow[] = []) {
    this.args.onChange?.(
      rows.map((r) => {
        const row = { ...r };
        delete row.index;
        return row;
      })
    );
  }
}
